import { InviteCode } from "@edu/shared";

/**
 * Приглашение преподавателя (раздел 9 `docs/admin-panel-design.md`): чистые
 * правила без React, чтобы проверять их встроенным `node:test`.
 *
 * Панель выписывает ссылку `/teacher-invite#<код>`. Код во ФРАГМЕНТЕ, как у
 * `/view`: фрагмент не уходит на сервер, не попадает ни в Referer, ни в
 * access-лог, а маскировка адреса заметки о неточности берёт только `pathname`.
 */

/** Код из фрагмента адреса, либо `null`, если там не код. Схема та же, что на сервере. */
export function readTeacherInviteCode(hash: string): string | null {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  const parsed = InviteCode.safeParse(raw);
  return parsed.success ? parsed.data : null;
}

/**
 * Адрес начала входа через Google с кодом приглашения.
 *
 * ⚠️ Параметр называется `k` не для краткости: access-лог Caddy вырезает из
 * строки запроса ровно его (разбор у маршрута `start` в
 * `apps/api/src/routes/auth-google.ts`). Другое имя легло бы в лог живым кодом.
 */
export function teacherInviteStartUrl(googleStart: string, code: string): string {
  return `${googleStart}?k=${encodeURIComponent(code)}`;
}
